<template>
  <div v-if="this.hasTimestampSelected" class="mt-2 col-md-12">
    <div class="mt-2 col-md-12"><strong>Relevant Transactions</strong></div>
    <b-card no-body>
      <b-row class="mx-1 mt-2 mb-1" align-h="between">
        <b-col lg="7" md="12" sm="12">
          <b-row align-h="between">
            <b-col lg="4" md="4" sm="12" class="mb-1">
              <div class="form-select">
                Show
                <b-form-select
                  v-model="perPage"
                  :options="options"
                  style="width: 60px;"
                  size="sm"
                ></b-form-select>
                Entries
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="5" md="12" sm="12" class="mb-1">
          <b-row align-h="end">
            <SearchBar :hasErrorMessage="true">
              <template #input>
                <b-form-input v-model="filter" type="search" placeholder="Search" />
              </template>
            </SearchBar>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div v-if="hasData">
            <b-table
              class="table-with-actions-min-height px-2"
              responsive
              striped
              outlined
              small
              :items="dnsDetailsFilter"
              :fields="computedTableFields"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              @filtered="onFiltered"
              select-mode="single"
              selectable
            >
            <template #cell(computedTimestamp)="data">
              <div>
                {{ moment(data.value).format(momentTimeFormat.dateTime) }}
              </div>
            </template>
            <template #cell(question)="data">
              <span v-b-tooltip.hover :title="data.value">
                {{ collapseText(data.value) }}
              </span>
            </template>
            <template #cell(answers)="data">
              <span v-b-tooltip.hover :title="data.value">
                {{ collapseText(data.value) }}
              </span>
            </template>
            <template #cell(flags)="data">
              <div v-for="(flag, index) in getItemPairs(data.item.flags)" :key="index">
                {{ flag }}
              </div>
            </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="paginationTotalRows"
              :per-page="perPage"
              align="right"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-2 mx-1"
            />
          </div>
          <div v-else-if="this.loaded" class="mx-1 pl-1 mb-1">
            {{ $t("No Data Available") }}
          </div>
          <SpinnerCmpt v-else></SpinnerCmpt>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';

import SecurityEventBus from '@/xvisor/bus/SecurityEventBus';
import SearchBar from '@/xvisor/components/SearchBar.vue';
import SpinnerCmpt from '@/xvisor/components/SpinnerCmpt.vue';
import collapseText from '@/xvisor/utilities/collapseText';
import hostnameFormatter from '@/xvisor/utilities/hostnameFormatter';
import momentTimeFormat from '@/xvisor/constants/momentTimeFormat';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  components: {
    SearchBar,
    SpinnerCmpt,
  },
  data() {
    return {
      dnsDetailsInfo: [],
      loaded: false,
      selectedTimestamp: null,
      currentPage: 1,
      perPage: 10,
      options: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 15, text: '15' },
      ],
      filter: null,
      filteredLength: null,
      tableFields: [
        { key: 'computedTimestamp', label: 'Time', sortable: true },
        { key: 'version', label: 'Version', sortable: true },
        { key: 'sourceIp', label: 'Source Ip', sortable: true },
        { key: 'destinationIp', label: 'Destination Ip', sortable: true },
        { key: 'direction', label: 'Direction', sortable: true },
        { key: 'question', label: 'Question', sortable: true },
        { key: 'answers', label: 'Answer', sortable: true },
        { key: 'response_code', label: 'Response Code', sortable: true },
        { key: 'flags', label: 'Flags', sortable: true },
        { key: 'rejected', label: 'Rejected', sortable: true },
      ],
      momentTimeFormat,
    };
  },
  created() {
    SecurityEventBus.$on('update-selected-timestamp', (timestamp) => {
      this.selectedTimestamp = timestamp;
    });
  },
  computed: {
    hasData() {
      return this.loaded && this.dnsDetailsInfo && this.dnsDetailsInfo.length > 0;
    },
    formattedDnsSmartSampler() {
      return Object.entries(this.dnsDetailsInfo.dns).map(([key, value]) => [key, value]);
    },
    paginationTotalRows() {
      if (this.filter) return this.filteredLength;
      return this.dnsDetailsInfo.length;
    },
    computedTableFields() {
      return this.tableFields;
    },
    dnsDetailsFilter() {
      const retVal = this.dnsDetailsInfo;
      return retVal;
    },
    hasTimestampSelected() {
      return this.selectedTimestamp !== null && this.selectedTimestamp !== undefined;
    },
  },
  methods: {
    httpGet() {
      this.loaded = false;
      const dnsSmartSamplerRequest = this.$http.get(this.url, {
        params: {
          time: this.selectedTimestamp,
        },
      });

      dnsSmartSamplerRequest
        .then((threatDetailsRes) => {
          this.dnsDetailsInfo = threatDetailsRes.data;
        })
        .finally(() => {
          this.loaded = true;
        });
    },
    onFiltered(filteredItems) {
      this.filteredLength = filteredItems.length;
      this.currentPage = 1;
    },
    getItemPairs(flags) {
      const pairs = {};
      const res = {};
      Object.entries(flags).forEach(([key, value]) => {
        pairs[key.toUpperCase()] = `${key.toUpperCase()}: ${value}`;
      });
      const {
        AA, TC, RD, RA, Z,
      } = pairs;
      res[0] = `${AA}, ${TC},`;
      res[1] = `${RD}, ${RA},`;
      res[2] = Z;
      return res;
    },
    collapseText,
    hostnameFormatter,
    moment,
  },
  watch: {
    selectedTimestamp() {
      this.httpGet();
    },
  },
};
</script>

<style scoped>
.form-select{
  min-width: 160px;
  width: 20%;
}
</style>
